import * as React from "react"

export interface PatchIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number
}

/**
 * Patch icon for ANYW3AR collection filter
 *
 * This icon represents patch items in the Trophy Room.
 *
 * @example
 * ```tsx
 * <PatchIcon />
 * <PatchIcon size={16} className="text-gray-500" />
 * ```
 */
export const PatchIcon = React.forwardRef<SVGSVGElement, PatchIconProps>(
  ({ size = 12, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path d="M9.9 10.92H9V10.32H9.3V10.02H9.9V10.92Z" fill="currentColor"/>
        <path d="M7.8001 10.92H6.6001V10.32H6.9601H7.8001V10.92Z" fill="currentColor"/>
        <path d="M3.0001 10.92H2.1001V10.02H2.7001V10.32H3.0001V10.92Z" fill="currentColor"/>
        <path d="M2.7001 8.87999H2.1001V7.73999H2.7001V8.15999V8.87999Z" fill="currentColor"/>
        <path d="M2.7001 1.98002H2.1001V1.08002H3.0001V1.68002H2.7001V1.98002Z" fill="currentColor"/>
        <path d="M9.9 1.98002H9.3V1.68002H9V1.08002H9.9V1.98002Z" fill="currentColor"/>
        <path d="M9.90005 8.87999H9.30005V8.27999V7.67999H9.90005V8.87999Z" fill="currentColor"/>
        <path d="M5.39995 1.68002H4.19995V1.08002H4.49995H5.39995V1.68002Z" fill="currentColor"/>
        <path d="M7.8001 1.68002H6.6001V1.08002H7.3201H7.8001V1.68002Z" fill="currentColor"/>
        <path d="M9.90005 4.25999H9.30005V3.78V3.12H9.90005V4.25999Z" fill="currentColor"/>
        <path d="M9.90005 6.60002H9.30005V5.88002V5.40002H9.90005V6.60002Z" fill="currentColor"/>
        <path d="M2.7001 4.25999H2.1001V3.12H2.7001V3.72V4.25999Z" fill="currentColor"/>
        <path d="M2.7001 6.60002H2.1001V5.40002H2.7001V6.18002V6.60002Z" fill="currentColor"/>
        <path d="M5.39995 10.92H4.19995V10.32H5.09995H5.39995V10.92Z" fill="currentColor"/>
      </svg>
    )
  }
)

PatchIcon.displayName = "PatchIcon"
